/**
 * Source is a model to wrap an Open Layers map source in a class that gives
 * it some additional properties for use in the app.
 */
export default class Source {
    constructor(id, name, source, maxZoom, cls) {
        this.id = id
        this.name = name
        this.source = source
        this.maxZoom = maxZoom
        this.class = cls
    }
}